module.exports = __webpack_public_path__ + "img/icon_transport.d67f8fe1.svg";